module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [_c('div', {
    staticClass: "anchors",
    attrs: {
      "slot": "anchors"
    },
    slot: "anchors"
  }, _vm._l((_vm.anchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: key === _vm.currentSection
      },
      attrs: {
        "href": '#' + key
      }
    }, [_vm._v(_vm._s(value))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.article.article_type.name))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', {
    staticClass: "ids"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.article.ids.doi))]), _vm._v("Issue: "), _c('span', [_vm._v("Volume " + _vm._s(_vm.article.volume) + ", Issue " + _vm._s(_vm.article.issue))]), _vm._v("pp " + _vm._s(_vm.article.page_start) + "-" + _vm._s(_vm.article.page_end))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  }), _vm._v(" "), (_vm.$store.state.isEnhanced) ? _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.article
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "full_text"
    },
    slot: "full_text"
  }, [_c('section', [_c('a', {
    staticClass: "jumpto hidden-md-up",
    on: {
      "click": function($event) {
        _vm.openNav()
      }
    }
  }, [_vm._v("Jump To")]), _vm._v(" "), _c('p'), _c('h1', {
    attrs: {
      "id": "Abstract"
    }
  }, [_vm._v("ABSTRACT")]), _vm._v(" "), _c('div', {
    staticClass: "fullText",
    domProps: {
      "innerHTML": _vm._s(_vm.article.abstract)
    }
  }), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._l((_vm.article.fullText.sections), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": sectionItem.headerLevel,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [(contentItem.contentType === 'subsection') ? [_c('content-header', {
        attrs: {
          "header-level": contentItem.headerLevel,
          "title": contentItem.title
        }
      }), _vm._v(" "), _vm._l((contentItem.content), function(subsectionItem) {
        return [_c('content-item', {
          attrs: {
            "content-item": subsectionItem
          }
        })]
      })] : _c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.article.fullText.acks), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": 1,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [_c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.article.fullText.footnotes), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": 1,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [_c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.article.fullText.references) ? _c('div', {
    staticClass: "fullText"
  }, [_c('section', [_c('a', {
    staticClass: "jumpto hidden-md-up",
    on: {
      "click": function($event) {
        _vm.openNav()
      }
    }
  }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
    attrs: {
      "header-level": 1,
      "title": 'References'
    }
  }), _vm._v(" "), _vm._l((_vm.article.fullText.references), function(reference) {
    return _c('p', {
      attrs: {
        "id": reference.id
      }
    }, [_c('span', [_vm._v(_vm._s(reference.number) + ". ")]), _vm._v(" "), _vm._l((reference.textContent), function(content) {
      return _c('span', [_vm._v(_vm._s(content.content))])
    })], 2)
  })], 2)]) : _vm._e()], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f64acd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/ArticleDetailPage.vue
// module id = 1431
// module chunks = 1